export default __webpack_public_path__ + "img/fad97fadb30f7b9abf1b7514ccaaea91.png";